/* Refillia: preferiti salvati nel browser (localStorage "rf-preferiti"), cuore in testata, foglio e pagina */
(function () {
  if (window.RfPref) return;
  var K = 'rf-preferiti';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGINA = root + 'pages/preferiti';
  var CUORE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3s-7.8-4.6-7.8-10.5A4.5 4.5 0 0 1 12 7.1a4.5 4.5 0 0 1 7.8 2.7c0 5.9-7.8 10.5-7.8 10.5Z"/></svg>';
  var CARRELLO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';

  function leggi() { try { return JSON.parse(localStorage.getItem(K) || '[]') || []; } catch (e) { return []; } }
  function scrivi(l) { try { localStorage.setItem(K, JSON.stringify(l)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function euro(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* cuore in testata, prima dell'account */
  function testata() {
    var azioni = document.querySelector('#header-component header-actions');
    if (!azioni || azioni.querySelector('.rf-pref-link')) return;
    var a = document.createElement('a');
    a.className = 'header-actions__action rf-pref-link';
    a.href = PAGINA;
    a.setAttribute('data-rf-pref-apri', '');
    a.innerHTML = CUORE + '<span class="rf-pref-n" hidden>0</span>';
    azioni.insertBefore(a, azioni.firstChild);
  }

  // scrive un attributo solo se cambia: niente ricalcoli di stile inutili
  function metti(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function aggiornaCuori(radice) {
    var l = leggi();
    if (!radice) {
      document.querySelectorAll('.rf-pref-n').forEach(function (n) { var t = String(l.length); if (n.hidden !== !l.length) n.hidden = !l.length; if (n.textContent !== t) n.textContent = t; });
      document.querySelectorAll('.rf-pref-link').forEach(function (a) { metti(a, 'aria-label', 'Preferiti, ' + l.length + (l.length === 1 ? ' prodotto' : ' prodotti')); });
    }
    var cuori = radice ? (radice.matches && radice.matches('[data-rf-pref]') ? [radice] : radice.querySelectorAll('[data-rf-pref]')) : document.querySelectorAll('[data-rf-pref]');
    Array.prototype.forEach.call(cuori, function (b) {
      var on = l.indexOf(b.getAttribute('data-rf-pref')) > -1;
      metti(b, 'aria-pressed', on ? 'true' : 'false');
      metti(b, 'aria-label', on ? 'Togli dai preferiti' : 'Aggiungi ai preferiti');
    });
  }
  function salta(el) { if (!el) return; el.classList.remove('rf-salta'); void el.offsetWidth; el.classList.add('rf-salta'); }

  function aggiungi(h) { var l = leggi(); if (l.indexOf(h) < 0) { l.unshift(h); scrivi(l); } aggiornaCuori(); salta(document.querySelector('.rf-pref-link')); avvisa(); }
  function togli(h) { var l = leggi().filter(function (x) { return x !== h; }); scrivi(l); aggiornaCuori(); avvisa(); }
  function cambia(h, el) {
    var l = leggi();
    if (l.indexOf(h) > -1) togli(h);
    else { aggiungi(h); salta(el); }
  }
  function avvisa() { document.dispatchEvent(new CustomEvent('rf:preferiti', { detail: { lista: leggi() } })); }

  /* dati prodotto, scelta del formato da 1 litro quando c'è */
  var cache = {};
  function prodotto(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function variante(p) {
    var v = p.variants.filter(function (x) { return /^1 litro$/i.test(x.title) && x.available; })[0];
    return v || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
  }

  /* foglio dei preferiti */
  var box = null, foglio = null, prima = null;
  function riga(p) {
    var v = variante(p);
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    var dett = v.title && v.title !== 'Default Title' ? v.title + ' · ' : '';
    return '<div class="rfp__li"><a class="rfk__riga-img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>'
      + '<div class="rfk__riga-t">' + (p.type ? '<small>' + esc(p.type) + '</small>' : '') + '<a href="' + esc(p.url) + '"><b>' + esc(p.title) + '</b></a>'
      + '<small>' + esc(dett) + '<b style="font-size:13px;color:#000">' + euro(v.price) + '</b></small>'
      + '<div class="rfk__riga-giu">' + (v.available ? '<button type="button" class="rfp__agg" data-rfp-agg="' + v.id + '">' + CARRELLO + 'Aggiungi al carrello</button>' : '<small>Non disponibile</small>')
      + '<button type="button" class="rfk__via" data-rfp-togli="' + esc(p.handle) + '">Togli</button></div></div></div>';
  }
  function vuoto() {
    return '<div class="rfp__vuoto"><span class="rfk__vuoto-ic">' + CUORE + '</span><b style="display:block;font-family:var(--rf-font-display,var(--font-heading--family));font-weight:400;font-size:21px">Ancora nessun preferito</b><p style="color:#5f6862;font-size:14px;margin:6px 0 0">Tocca il cuore su un prodotto: lo ritrovi qui e nella pagina dei preferiti.</p></div>';
  }
  function disegna() {
    if (!box) return;
    var l = leggi(), corpo = box.querySelector('[data-rfp-corpo]');
    box.querySelector('[data-rfp-n]').textContent = l.length;
    if (!l.length) { corpo.innerHTML = vuoto(); return; }
    Promise.all(l.map(prodotto)).then(function (ps) {
      var righe = ps.filter(Boolean).map(riga).join('');
      corpo.innerHTML = righe || vuoto();
    });
  }
  function apri() {
    box = document.getElementById('rfp');
    if (!box) { location.href = PAGINA; return; }
    foglio = box.querySelector('.rfk__foglio');
    prima = document.activeElement;
    disegna();
    box.hidden = false;
    document.documentElement.classList.add('rfk-bloccato');
    void foglio.offsetWidth;
    box.classList.add('is-aperto');
  }
  function chiudi() {
    if (!box) return;
    box.classList.remove('is-aperto');
    document.documentElement.classList.remove('rfk-bloccato');
    setTimeout(function () { if (!box.classList.contains('is-aperto')) box.hidden = true; }, 430);
    if (prima && prima.focus) prima.focus({ preventScroll: true });
  }

  /* clic: cuori nelle schede (dentro il link della scheda), cuore in testata, foglio */
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-rf-pref], [data-rf-pref-apri]');
    if (t) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (t.hasAttribute('data-rf-pref-apri')) apri();
      else cambia(t.getAttribute('data-rf-pref'), t);
      return;
    }
    if (!box || box.hidden) return;
    var b = e.target.closest && e.target.closest('[data-rfp-chiudi], [data-rfp-agg], [data-rfp-togli]');
    if (!b || !box.contains(b)) return;
    if (b.hasAttribute('data-rfp-chiudi')) { chiudi(); return; }
    if (b.hasAttribute('data-rfp-togli')) { togli(b.dataset.rfpTogli); disegna(); return; }
    if (b.hasAttribute('data-rfp-agg')) {
      b.classList.add('fatto');
      b.textContent = 'Aggiunto';
      chiudi();
      if (window.RfCarrello) setTimeout(function () { window.RfCarrello.aggiungi(b.dataset.rfpAgg, null); }, 250);
    }
  }, true);
  /* tastiera: i pulsanti dentro le schede sono span con role="button" */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box && !box.hidden) { chiudi(); return; }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('[data-rf-pref], [data-rf-agg]');
    if (!t) return;
    e.preventDefault();
    t.click();
  });
  window.addEventListener('storage', function (e) { if (e.key === K) aggiornaCuori(); });

  /* schede che arrivano dopo (carica altri, ricerca): si ricolorano solo i cuori nuovi.
     Le scritte che cambiano (orologi, animazioni) non contano: si guardano solo gli elementi aggiunti. */
  var nuovi = [], attesa = false;
  new MutationObserver(function (lista) {
    for (var i = 0; i < lista.length; i++) {
      var add = lista[i].addedNodes;
      for (var j = 0; j < add.length; j++) {
        var el = add[j];
        if (el.nodeType !== 1) continue;
        if ((el.matches && el.matches('[data-rf-pref], header-actions, #header-component')) || (el.querySelector && el.querySelector('[data-rf-pref], header-actions'))) nuovi.push(el);
      }
    }
    if (!nuovi.length || attesa) return;
    attesa = true;
    setTimeout(function () {
      attesa = false;
      var q = nuovi; nuovi = [];
      testata();
      q.forEach(function (el) { if (el.isConnected) aggiornaCuori(el); });
      aggiornaNumero();
    }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });
  function aggiornaNumero() {
    var l = leggi();
    document.querySelectorAll('.rf-pref-n').forEach(function (n) { var t = String(l.length); if (n.hidden !== !l.length) n.hidden = !l.length; if (n.textContent !== t) n.textContent = t; });
    document.querySelectorAll('.rf-pref-link').forEach(function (a) { metti(a, 'aria-label', 'Preferiti, ' + l.length + (l.length === 1 ? ' prodotto' : ' prodotti')); });
  }

  window.RfPref = { leggi: leggi, aggiungi: aggiungi, togli: togli, apri: apri, prodotto: prodotto, variante: variante };
  function via() { testata(); aggiornaCuori(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', via); else via();
})();
